<template>
  <b-card no-body class="card-profile" alt="Image placeholder" img-top>
    <b-card-header class="text-center" style="min-height:10vw">
      <div class="card-profile-image hidden-sm-only">
        <a href="#" class="hidden-sm-only">
          <img src="@/assets/avatar.png" rounded="circle" class="hidden-sm-only" style="width: 100%" />
        </a>
      </div>
    </b-card-header>
    <b-card-body>
      <div class="text-center">
        <h5 class="h3">
          INFORMACION PERSONAL<span class="font-weight-light"></span>
        </h5>
        <div class="m-2">
          Nombre: {{ user.name }}
        </div>
        <div class="m-2">
          Email: {{ user.email }}
        </div>
        <div class="m-2">
          Password: {{ user.password_text }}
        </div>
        <div class="m-2">
          Identificacion: {{ user.identification }}
        </div>
        <div class="m-2">
          Telefono: {{ user.phone }}
        </div>
        <div class="m-2">
          Estado: {{ user.isActive|status }}
        </div>
        <div class="m-2">
          Numero de cuenta: {{ user.account_number }}
        </div>
        <div class="m-2">
          Fecha registro: {{ user.created_at|formatDate }}
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "Detail_Personal",
  props: {
    user: {
      default: {
        name: null,
        email: null,
        password_text: null,
        identification: null,
        phone: null,
        isActive: null,
        created_at: null,
        account_number: null,
      }
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .hidden-sm-only{
    display:none;
  }
}
</style>
